import { render, staticRenderFns } from "./results-container.vue?vue&type=template&id=2180c21f&scoped=true"
import script from "./results-container.vue?vue&type=script&lang=js"
export * from "./results-container.vue?vue&type=script&lang=js"
import style0 from "./results-container.vue?vue&type=style&index=0&id=2180c21f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180c21f",
  null
  
)

export default component.exports